import React, {useEffect, useRef, useState} from "react";
import styles from "./SelectBox.module.scss";
import Button from "../mainButton/Button";
import InfiniteScroller from "../InfiniteScroller/InfiniteScroller";
import {useFetch} from "../../../hooks/useFetch.hook";
import {isObject} from "chart.js/helpers";

const SelectBox = ({
                     children,
                     label = null,
                     header = null,
                     dropDownValue,
                     boxStyle = 'primary',
                     style = null,
                     arrow = null,
                     emptyTitle = "Select an Item",
                     optionsContainerWidth = null,
                     block,
                     singleSelect,
                     multiSelect,
                     options,
                     onSelectOption,
                     showInput = true,
                     showDropdown,
                     onCloseDropdown,
                     optionsStyle,
                     dontShowSearch,
                     searchStyle,
                     customButtons,
                     infiniteScroll,
                     onFetchData,
                     searchByApi,
                     onSearchResult,
                     searchResult,
                     propsSearchUrl
                   }) => {

  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [optionsToShow, setOptionsToShow] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([])
  const [searchUrl, setSearchUrl] = useState(null)
  const [searchValue, setSearchValue] = useState()
  const [initialLoaded, setInitialLoaded] = useState(false);

  const handleTriggerOpenDropDown = (e) => {
    e.stopPropagation();
    setIsOpenDropDown(!isOpenDropDown);
  }

  useEffect(() => {
    if (showDropdown !== undefined) {
      setIsOpenDropDown(showDropdown)
    }
  }, [showDropdown])

  useEffect(() => {
    if ((multiSelect || singleSelect) && options?.length) {
      setDropdownOptions(options)
      setOptionsToShow(options)
    }
  }, [options?.length])

  const handleSelectSingleOption = (option) => {
    onSelectOption(option)
    setTimeout(() => {
      setIsOpenDropDown(false)
    }, 50)
  }

  const handleSelectOption = (option) => {
    if (option === "remove") {
      onSelectOption([])
    } else {
      const selectedOptionsList = [...dropDownValue]
      const findIndex = selectedOptionsList.findIndex(item => item === option)

      if (selectedOptionsList.length && findIndex !== -1) {
        selectedOptionsList.splice(findIndex, 1)
      } else {
        selectedOptionsList.push(option)
      }
      onSelectOption(selectedOptionsList)
    }
  }

  const handleSearch = (e) => {
    const value = e.target.value.trim()
    if (value.length !== 0) {
      const filtered = dropdownOptions.filter(user => user.toLowerCase().includes(value.toLowerCase()));
      if (!filtered || filtered.length === 0) {
        setOptionsToShow([]);
      } else {
        setOptionsToShow(filtered);
      }
    } else {
      setOptionsToShow(options)
    }
  }
    const getInitialUrl = () =>
        propsSearchUrl?.endsWith("&search")
            ? propsSearchUrl.slice(0, -"&search".length)
            : propsSearchUrl;

    useEffect(() => {
        if (!searchByApi) return;

        // فقط بار اول، وقتی دراپ‌داون باز شد
        if (isOpenDropDown && !initialLoaded) {
            setSearchUrl(getInitialUrl()); // => "/authentication/user_management?page=1"
            setInitialLoaded(true);
        }
    }, [isOpenDropDown, searchByApi, initialLoaded]);


    const fetchedSearchResults = useFetch(searchUrl)
  useEffect(() => {
    if (!fetchedSearchResults?.status?.isLoading) {
      if (fetchedSearchResults?.status?.isSuccess) {
        onSearchResult(fetchedSearchResults, searchValue)
        setSearchUrl(null)
      }
    }
  }, [fetchedSearchResults?.data])

  useEffect(() => {
    if (searchByApi) {
      if (searchResult?.length) {
        setOptionsToShow(searchResult);
      } else {
        setOptionsToShow([]);
      }
    }
  }, [searchResult])

  const handleSearchByApi = (e) => {
    const value = e.target.value.trim()
    setSearchValue(value)
    if (value.length !== 0 && value.length >= 3) {
      setSearchUrl(`${propsSearchUrl}=${value}`)
    } else {
      setOptionsToShow(options)
      if (value.length === 0) {
        onSearchResult && onSearchResult()
      }
    }
  }

  const selectBoxRef = useRef()

    const handleClickOutside = (e) => {
        if (!selectBoxRef.current?.contains(e.target)) {
            if (isOpenDropDown) {
                setIsOpenDropDown(false);

                // ریست لود اولیه تا بار بعد دوباره fetch بزنه
                setInitialLoaded(false);

                if (onCloseDropdown) {
                    onCloseDropdown(false);
                }
            }
        }
    };


  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => document.removeEventListener('mouseup', handleClickOutside);
  })

  const renderOptions = () => {
    if (singleSelect) {
      return optionsToShow.map((option, key) => {
        return <div onClick={() => handleSelectSingleOption(option)} className={styles.singleSelectOption} key={`${option.title}_${key}`}>
          {option.title}
        </div>
      })
    } else {
      return optionsToShow.map((option, key) => {
        return <label key={`${option.title}_${key}`} className={styles.bContain} onChange={(e) => handleSelectOption(option.value)}>
          <span>{option.title}</span>
          <input className={dropDownValue?.some(item => item === option.value) && styles.checked} type="checkbox"
                 value={option.value}/>
          <div className={styles.bInput}></div>
        </label>
      })
    }
  }

  return (
    <div className={[styles.SelectBox].join(' ')}>
      <div>
        {label}
      </div>
      <div
        onClick={(e) => {
          if (multiSelect || singleSelect) {
            setIsOpenDropDown(true)
          } else {
            handleTriggerOpenDropDown(e)
          }
        }}
        className={`${styles.customSelectWrapper} ${label ? 'mt-2' : ''}`}
        tabIndex={-1}
      >
        <div ref={selectBoxRef} className={[styles.customSelect, (isOpenDropDown ? styles.open : null)].join(' ')}>
          {
            showInput && <div style={style}
                             className={[styles.customSelect__trigger, (block && styles.block), (boxStyle === "transparent") ? styles.transparent : ''].join(' ')}>
              <div className={'d-flex align-items-center'}>
                {multiSelect ?
                  dropDownValue.length ?
                    <>
                      <div>
                        {dropDownValue[0]}
                      </div>
                      <div>
                        {
                          dropDownValue.length > 1 && `, +${dropDownValue.length - 1} more`
                        }
                      </div>
                    </>
                    : emptyTitle
                  : isObject(dropDownValue) ? dropDownValue.title || dropDownValue : dropDownValue || emptyTitle}
              </div>
              <div className={[styles.arrow, (isOpenDropDown ? styles.open : null)].join(' ')}>
                {
                  arrow ? arrow : (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.8332 7.08334L9.99984 12.9167L4.1665 7.08334" stroke="#0A195C" strokeWidth="1.5"
                            strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )
                }
              </div>
            </div>
          }
          <div
               className={[styles.customOptions, multiSelect && styles.multiSelect].join(' ')}
               style={{width: optionsContainerWidth, ...optionsStyle}}
          >
            {header}
            {
              multiSelect || singleSelect ?
                <section className={styles.multiSelectWrapper}>
                  {
                    !dontShowSearch && <div className={[styles.searchInputWrapper, searchStyle === "secondary" && styles.secondarySearchStyle].join(' ')}>
                      <input type={"search"} placeholder={"Search..."} className={[styles.searchInput].join(' ')}
                             onChange={searchByApi ? handleSearchByApi : handleSearch}
                      />
                    </div>
                  }
                  {
                    infiniteScroll
                      ? <InfiniteScroller maxHeight={172} onFetchData={onFetchData}>
                        {renderOptions()}
                      </InfiniteScroller>
                      : <div className={styles.optionsWrapper}>
                        {renderOptions()}
                      </div>
                  }
                  <div className={'mt-2'}>
                    {
                      customButtons ? customButtons
                        : multiSelect && <Button onClick={() => handleSelectOption('remove')} block type={"outlined"} color={"primary"}
                                size={"small"}>
                          Clear All
                        </Button>
                    }
                  </div>
                </section> :
                <>
                  {children}
                </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectBox;